import styled from 'styled-components'

const StepButtonTextUi = styled.span`
  font-weight: bold;
  font-size: 18px;
`

export default StepButtonTextUi